/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1577
 */

"use strict"

module.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"
